//import md5 from 'js-md5'

const base = { 
 // 储存Cookie
	setcookie : function(name,value){ 
		value= base.toCode(value)
		document.cookie = name+"="+value+";path=/";
	},
	getCookie:function(c_name){

  //判断document.cookie对象里面是否存有cookie
	  let mycookie=""
	  if (document.cookie.length>0){
	  let  c_start=document.cookie.indexOf(c_name + "=")
		//如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
		if (c_start!=-1){ 
		  c_start=c_start + c_name.length+1 
		 let c_end=document.cookie.indexOf(";",c_start)
		  if (c_end==-1) c_end=document.cookie.length
		
		  mycookie = unescape(document.cookie.substring(c_start,c_end))
		  mycookie = base.fromCode(mycookie)
		  return mycookie
		  } 
		}
	  return mycookie
	},
 
//加密字符串
	toCode:function(str) {  
		str = str.toString()
		//定义密钥，36个字母和数字
		let key = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
		let l = key.length;  //获取密钥的长度
		let a = key.split("");  //把密钥字符串转换为字符数组
		let s = "",b, b1, b2, b3;  //定义临时变量
		for (let i = 0; i <str.length; i ++) {  //遍历字符串
			b = str.charCodeAt(i);  //逐个提取每个字符，并获取Unicode编码值
			b1 = b % l;  //求Unicode编码值得余数
			b = (b - b1) / l;  //求最大倍数
			b2 = b % l;  //求最大倍数的于是
			b = (b - b2) / l;  //求最大倍数
			b3 = b % l;  //求最大倍数的余数
			s += a[b3] + a[b2] + a[b1];  //根据余数值映射到密钥中对应下标位置的字符
		}
		return s;  //返回这些映射的字符
	}, 

// 解密字符串
	fromCode:function (str) {
		//定义密钥，36个字母和数字
		let key = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
		let l = key.length;  //获取密钥的长度
		let b, b1, b2, b3, d = 0, s;  //定义临时变量
		s = new Array(Math.floor(str.length / 3));  //计算加密字符串包含的字符数，并定义数组
		b = s.length;  //获取数组的长度
		for (let i = 0; i < b; i ++) {  //以数组的长度循环次数，遍历加密字符串
			b1 = key.indexOf(str.charAt(d));  //截取周期内第一个字符串，计算在密钥中的下标值
			d ++;
			b2 = key.indexOf(str.charAt(d));  //截取周期内第二个字符串，计算在密钥中的下标值
			d ++;
			b3 = key.indexOf(str.charAt(d));  //截取周期内第三个字符串，计算在密钥中的下标值
			d ++;
			s[i] = b1 * l * l + b2 * l + b3  //利用下标值，反推被加密字符的Unicode编码值
		}
		b = eval("String.fromCharCode(" + s.join(',') + ")");   //用fromCharCode()算出字符串
		return b ;  //返回被解密的字符串
	},
// 特殊需求，数字保留位数
	changeNumber:function(num){
		if(num===undefined){
		  num = 0
		}
		if(num==NaN){
		  num = 0
		}
		let number
		let _num = Number(num)
		_num = _num.toFixed(2)

		let firstNum = _num.split(".")[0]
		let lastNum = _num.split(".")[1]

		let lastNum1 = lastNum.split("")[0]
		let lastNum2 = lastNum.split("")[1]

		if (lastNum2=="0"){
		  if (lastNum1 == "0"){
			number = firstNum
		  }else{
			number = firstNum + "." + lastNum1
		  }
		}else{
		  number = _num
		}
		return number
	},
//对象字母升序排序
objSort(obj) { 
    var newkey = Object.keys(obj).sort();
    var newObj = {};
    for (var i = 0; i < newkey.length; i++) {
		if(obj[newkey[i]]){
			newObj[newkey[i]] = obj[newkey[i]];
		}
    }
    return newObj;                       //返回排好序的新对象
},
// 加签
sign(obj){
		let _data =Object.assign({},obj)
		if(_data.sign){
			delete _data.sign
		}
		if(_data.timestamp){
			delete _data.timestamp
		}
		let _timestamp = parseInt(new Date().getTime()/1000)
		_data.timestamp = _timestamp
		_data.key = "74260f176fef3fe877351cf446c981c8"
		_data = base.objSort(_data)
		let _string = ""
		
	   for(let name in _data) {
			
			if(typeof _data[name]=="object"){
				_data[name] = JSON.stringify(_data[name])
			}
			
			_string += name + "="+ _data[name] + "&"
		
		}
	
		_string=_string.substring(0,_string.length-1)
		
	
		obj.timestamp = _timestamp
		obj.sign = md5(_string).toUpperCase()
		return obj
		
}




}
export default base